import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuilding,
    faClockRotateLeft,
    faFileInvoice,
    faUserTie,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';

const LeftBar = ({ isCollapsed = false, isMobileOpen = false, onNavigate = () => { } }) => {
    const location = useLocation();
    const { role } = useAuth();

    const menuItems = [
        {
            label: 'Invoice',
            path: '/',
            icon: faFileInvoice,
            visible: role === 'Admin' || role === 'Sender',
        },
        {
            label: 'Invoice History',
            path: '/invoice-history',
            icon: faClockRotateLeft,
            visible: true,
            activePaths: ['/invoice-history', '/invoice-detail'],
        },
        {
            label: 'Vendors',
            path: '/vendors',
            icon: faBuilding,
            visible: true,
        },
        {
            label: 'Users',
            path: '/users',
            icon: faUsers,
            visible: role === 'Admin',
        },
        {
            label: 'Financial Controllers',
            path: '/financial-controllers',
            icon: faUserTie,
            visible: role === 'Admin',
        },
    ];

    const isItemActive = (item) => {
        if (item.path === '/') {
            return location.pathname === '/';
        }

        return item.activePaths
            ? item.activePaths.some((path) => location.pathname.startsWith(path))
            : location.pathname === item.path;
    };

    return (
        <aside className={`left-bar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
            <nav aria-label="Main navigation">
                <ul className="left-bar-menu">
                    {menuItems
                        .filter((item) => item.visible)
                        .map((item) => (
                            <li key={item.path} className="left-bar-menu-item">
                                <NavLink
                                    to={item.path}
                                    className={`left-bar-link ${isItemActive(item) ? 'active' : ''}`}
                                    onClick={onNavigate}
                                    title={isCollapsed ? item.label : undefined}
                                >
                                    <span className="left-bar-icon">
                                        <FontAwesomeIcon icon={item.icon} />
                                    </span>
                                    <span className="left-bar-label">{item.label}</span>
                                </NavLink>
                            </li>
                        ))}
                </ul>
            </nav>
        </aside>
    );
};

export default LeftBar;
